import { Card, CardContent } from "../components/ui/card";
import { HelpCircle, MessageSquare, PlayCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useConsultation } from "../context/ConsultationContext";
import { Button } from "../components/ui/button";

const faqs = [
  { q: "What is the StaffLink Demo Centre?", a: "A collection of seven fully-interactive automation demos you can play with to feel how StaffLink Ghana would transform your business." },
  { q: "Is the data real?", a: "No — all data on the demos is realistic sample data. Your consultation requests are stored securely." },
  { q: "How long does implementation take?", a: "Most StaffLink automations go live within 2 weeks of the strategy call." },
  { q: "Do you support WhatsApp Business?", a: "Yes — every demo has a WhatsApp counterpart, including the receptionist and appointment reminders." },
];

export default function HelpPage() {
  const { openWith } = useConsultation();
  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-xs font-semibold uppercase tracking-widest text-primary">Help centre</div>
      <h1 className="mt-1 font-display text-3xl sm:text-4xl">How can we help?</h1>
      <p className="mt-3 text-muted-foreground max-w-2xl">Quick answers, or reach a StaffLink specialist directly.</p>

      <div className="mt-8 grid md:grid-cols-3 gap-4">
        <Link to="/demo/receptionist" className="glass rounded-2xl p-5 hover:-translate-y-0.5 transition-transform">
          <PlayCircle className="w-5 h-5 text-primary"/><div className="mt-3 font-semibold">Start with the receptionist demo</div>
          <div className="text-xs text-muted-foreground mt-1">Chat with Ama, our real AI receptionist.</div>
        </Link>
        <button onClick={() => openWith({})} className="text-left glass rounded-2xl p-5 hover:-translate-y-0.5 transition-transform">
          <MessageSquare className="w-5 h-5 text-primary"/><div className="mt-3 font-semibold">Book a free strategy call</div>
          <div className="text-xs text-muted-foreground mt-1">30 minutes with a StaffLink specialist.</div>
        </button>
        <Link to="/contact" className="glass rounded-2xl p-5 hover:-translate-y-0.5 transition-transform">
          <HelpCircle className="w-5 h-5 text-primary"/><div className="mt-3 font-semibold">Send a message</div>
          <div className="text-xs text-muted-foreground mt-1">We reply within one business hour.</div>
        </Link>
      </div>

      <div className="mt-10 space-y-3">
        <div className="font-display text-xl">Frequently asked</div>
        {faqs.map((f) => (
          <Card key={f.q} className="glass"><CardContent className="p-5">
            <div className="font-semibold">{f.q}</div>
            <p className="text-sm text-muted-foreground mt-1">{f.a}</p>
          </CardContent></Card>
        ))}
      </div>
    </div>
  );
}
